export default __webpack_public_path__ + "static/media/2905.049bcc32.png";